import * as C from '../common/constants';
import { makeStyles, createStyles, StyleRules } from '@mui/styles';
import { ReactComponent as IconLogo } from '../assets/tarragon_logo.svg';
import { useTranslations } from '../common/hooks/useTranslations';
import { useSelector, useDispatch } from 'react-redux';
import { EMenus } from '../common/enums';

const useStyles = makeStyles(
  (theme: any): StyleRules =>
    createStyles({
      logoStyle: {
        paddingBottom: '10px',
      },
      labelStyle: {
        fontFamily: theme.typography.fontFamily,
        fontWeight: 400,
        fontSize: '16px',
        lineHeight: '16px',
        letterSpacing: '2px',
        wordSpacing: '10px',
        whiteSpace: 'nowrap',
      },
      '@media only screen and (max-height: 640px)': {
        logoStyle: {
          paddingBottom: '6px',
        },
        labelStyle: {
          fontSize: '12px',
          lineHeight: '12px',
        },
      },
    })
);

const Header = (): JSX.Element => {
  const classes = useStyles();

  const appData = useSelector((state: any) => state.app[C.APP_DATA]);
  const labels = appData?.labels;

  return (
    <>
      <IconLogo className={classes.logoStyle} />
      {labels && <span className={classes.labelStyle}>{labels?.title}</span>}
    </>
  );
};

export default Header;
